import React, { useState } from 'react'
import { finalRank } from '../../utils/filters'
import Flag from '../common/Flag'

export default function TeamCompetitionTable({ results, current, status, expandAll, onToggleAll }) {
  const [expandedTeams, setExpandedTeams] = useState(() => {
    // Initialize all teams as expanded by default
    const initial = {}
    results?.forEach((_, index) => {
      initial[index] = true
    })
    return initial
  })

  // Update expanded state when expandAll prop changes
  React.useEffect(() => {
    if (expandAll !== undefined) {
      const newExpandedTeams = {}
      results?.forEach((_, index) => {
        newExpandedTeams[index] = expandAll
      })
      setExpandedTeams(newExpandedTeams)
    }
  }, [expandAll, results])

  const toggleTeam = (index) => {
    setExpandedTeams(prev => ({
      ...prev,
      [index]: !prev[index]
    }))
  }

  const isHighlighted = (row) => {
    if (!current) return false
    
    // For team competition, highlight by removing last character from bib
    const bib = ['r1', 'r2', 'r3', 'r4'].includes(status) 
      ? String(current.bib).slice(0, -1) 
      : String(current.bib)
    
    return bib === String(row.bib)
  }

  // Check if team is not finished (some jumpers haven't jumped yet)
  const isNotFinished = (team, allResults) => {
    const jumpCount = Math.max(...allResults.map(t => 
      t.results.filter(r => r.length1 !== null || r.dq || r.dns || r.nps).length
    ))
    return team.results.length < jumpCount
  }

  if (!results || results.length === 0) {
    return <p>No results available</p>
  }

  return (
    <table className="resultstable" cellSpacing="0" cellPadding="0" width="100%">
      <thead>
        <tr>
          <th width="50" className="text-center">Rank</th>
          <th width="50" className="text-center">Bib</th>
          <th></th>
          <th width="50">Nat.</th>
          <th className="text-center">Total</th>
        </tr>
      </thead>
      <tbody>
        {results.map((team, teamIndex) => (
          <React.Fragment key={teamIndex}>
            {/* Team Row */}
            <tr 
              className={`${teamIndex % 2 === 0 ? 'even' : 'odd'} ${
                isNotFinished(team, results) ? 'not-finished' : ''
              } ${isHighlighted(team) ? 'highlight' : ''}`}
              onClick={() => toggleTeam(teamIndex)}
              style={{ cursor: 'pointer' }}
            >
              <td width="50" className="text-center">{finalRank(team)}</td>
              <td width="60" className="text-center">{team.bib}</td>
              <td>{team.nation?.toUpperCase()}</td>
              <td width="50">
                <Flag code={team.nation} />
              </td>
              <td width="100" className="text-center">
                {team.total ? (typeof team.total === 'number' ? team.total.toFixed(1) : parseFloat(team.total).toFixed(1)) : '-'}
              </td>
            </tr>
            
            {/* Individual Jumpers - Expandable */}
            {expandedTeams[teamIndex] && team.results && (
              <tr>
                <td colSpan="5" style={{ padding: 0, backgroundColor: '#f9f9f9' }}>
                  <table width="100%" cellSpacing="0" cellPadding="0" style={{ margin: '10px 0' }}>
                    <thead>
                      <tr style={{ backgroundColor: '#e0e0e0' }}>
                        <th className="text-center">Bib</th>
                        <th className="text-center"></th>
                        <th>Name</th>
                        <th className="text-center hide-for-small">Speed</th>
                        <th className="text-center">Dist.1</th>
                        <th className="text-center">Dist.2</th>
                        <th className="text-center">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {team.results.map((jumper, jumperIndex) => (
                        <tr key={jumperIndex} style={{ backgroundColor: 'white' }}>
                          <td width="50" className="text-center">{jumper.bib}</td>
                          <td width="50" className="text-center">{finalRank(jumper)}</td>
                          <td>{jumper.name}</td>
                          <td width="60" className="extra text-center hide-for-small">
                            {jumper.speed ? (typeof jumper.speed === 'number' ? jumper.speed.toFixed(1) : parseFloat(jumper.speed).toFixed(1)) : '-'}
                          </td>
                          <td width="60" className="text-center">
                            {jumper.length1 ? (typeof jumper.length1 === 'number' ? jumper.length1.toFixed(1) : parseFloat(jumper.length1).toFixed(1)) : '-'}
                          </td>
                          <td width="60" className="text-center">
                            {jumper.length2 ? (typeof jumper.length2 === 'number' ? jumper.length2.toFixed(1) : parseFloat(jumper.length2).toFixed(1)) : '-'}
                          </td>
                          <td width="60" className="text-center">
                            {jumper.total ? (typeof jumper.total === 'number' ? jumper.total.toFixed(1) : parseFloat(jumper.total).toFixed(1)) : '-'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </td>
              </tr>
            )}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  )
}
